import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EaDisplay } from '@app/components/pr-display';

export class PrSelectOption {
  label: string;
  value: any;

  constructor(label: string, value: any) {
    this.label = label;
    this.value = value;
  }
}

@Component({
    selector: 'pr-select',
    templateUrl: './pr-select.component.html',
    styleUrls: ['./pr-select.component.scss'],
    standalone: false
})
export class PrSelectComponent {
  @Input() display: EaDisplay;
  @Input() clazz: string;
  @Input() options: PrSelectOption[] = [];
  @Input() updateOptions: ((value: any) => PrSelectOption[]) | undefined;
  @Input() value: any;
  @Input() placeholder: string = '';
  @Input() disabled: boolean = false;

  @Output() onSelectionChange: EventEmitter<any> = new EventEmitter();

  constructor() {}

  get currentOptions() {
    // If updateOptions is provided, compute dynamicaly options
    if (this.updateOptions && this.value !== undefined) {
      return this.updateOptions(this.value);
    }
    return this.options;
  }

  change(event: Event) {
    this.onSelectionChange.emit(event);
  }

  trackByValue(_index: number, option: PrSelectOption): any {
    return option.value;
  }
}
